import { AI_REQUEST_FREE_TIER_LIMIT, MAX_FREE_THEMES } from "@/lib/constants";

type Feature = {
  description: string;
  status: "done" | "pending";
};

export const FREE_SUB_FEATURES: Feature[] = [
  { description: "Customização total de temas", status: "done" },
  { description: `${AI_REQUEST_FREE_TIER_LIMIT} temas gerados por IA`, status: "done" },
  { description: `Salve e compartilhe até ${MAX_FREE_THEMES} temas`, status: "done" },
  { description: "Importe temas usando variáveis CSS", status: "done" },
  { description: "Exporte temas via variáveis CSS", status: "done" },
  { description: "Exporte temas via comando Shadcn Registry", status: "done" },
  { description: "Verificador de contraste", status: "done" },
];

export const PRO_SUB_FEATURES: Feature[] = [
  { description: "Salve e compartilhe temas ilimitados", status: "done" },
  { description: "Temas gerados por IA ilimitados", status: "done" },
  { description: "Gere temas a partir de imagens usando IA", status: "done" },
  { description: "Suporte prioritário", status: "done" },
  { description: "Salve seus próprios tipos de letra e cores", status: "pending" },
];
